import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';

import { CiHeart } from "react-icons/ci";
import { FaHeart } from "react-icons/fa";
import { Link } from 'react-router-dom';
import { useAuthContext } from '../Context/AuthContext';

// const pages = ['Home', 'Products', 'Contact Us', 'About Us', "Terms & Conditions"];
const pages = [
    { title: "Home", path: "/" },
    { title: "Products", path: "/products" },
    { title: "Contact Us", path: "/contact-us" },
    { title: "About Us", path: "/about-us" },
    { title: "Terms & Conditions", path: "/terms-conditions" },
    { title: "Privacy Policy", path: "/privacy-policy" },
    { title: "Refund & Return", path: "/refund-return" },
];
const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

function Header() {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);

    const { menu, setMenu } = useAuthContext()

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    return (
        <AppBar position="static" sx={{ bgcolor: 'white', color: 'black' }}>
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    {/* Desktop Logo */}
                    <Box sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }}>
                        <img src="./logo/logo.png" alt="Logo" style={{ height: '50px', width: '50px' }} />
                    </Box>

                    {/* Mobile Menu Icon */}
                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        <IconButton size="large" aria-label="open navigation menu" aria-controls="menu-appbar" aria-haspopup="true" onClick={handleOpenNavMenu} color="inherit">
                            <MenuIcon />
                        </IconButton>
                        <Menu id="menu-appbar" anchorEl={anchorElNav} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} keepMounted transformOrigin={{ vertical: 'top', horizontal: 'left' }} open={Boolean(anchorElNav)} onClose={handleCloseNavMenu} sx={{ display: { xs: 'block', md: 'none' } }}>
                            {pages.map((page, ind) => (
                                <Link to={page?.path} key={page.title} style={{ textDecoration: 'none' }} onClick={() => setMenu({ title: page?.title, active: ind })}>
                                    <MenuItem key={page} onClick={handleCloseNavMenu}
                                        sx={{
                                            my: 2, mx: 1, color: menu.active == ind ? '#f5b600' : 'black', border: 'none', position: 'relative',
                                            transition: 'color 0.3s ease, transform 0.3s ease',
                                            '&:hover': {
                                                color: '#f5b600', // Hover color
                                                transform: 'translateX(5px)', // Slight move to the right
                                            },
                                            '&::after': {
                                                content: '""',
                                                position: 'absolute',
                                                width: '100%',
                                                height: '2px',
                                                backgroundColor: '#f5b600',
                                                left: 0,
                                                bottom: 0,
                                                transform: menu.active == ind ? 'scaleX(1)' : 'scaleX(0)',
                                                transformOrigin: 'left',
                                                transition: 'transform 0.3s ease',
                                            },
                                            '&:hover::after': {
                                                transform: 'scaleX(1)', // Line grows from left to right
                                            },
                                        }}
                                    >
                                        <Typography sx={{ textAlign: 'center', color: menu.active == ind ? '#f5b600' : 'black' }}>{page?.title}</Typography>
                                    </MenuItem>
                                </Link>
                            ))}
                        </Menu>
                    </Box>

                    {/* Mobile Logo */}
                    <Box sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }}>
                        <img src="./logo/logo.png" alt="Logo" style={{ height: '50px', width: '50px' }} />
                    </Box>

                    {/* Desktop Links */}
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent: 'center' }}>
                        {pages.map((page, ind) => (
                            <Link to={page?.path} key={page.title} style={{ textDecoration: 'none' }} onClick={() => setMenu({ title: page?.title, active: ind })}>
                                <Button key={page} onClick={handleCloseNavMenu}
                                    sx={{
                                        my: 2, mx: 1, color: menu.active == ind ? '#f5b600' : 'black', border: 'none', position: 'relative',
                                        transition: 'color 0.3s ease, transform 0.3s ease',
                                        '&:hover': {
                                            color: '#f5b600', // Hover color
                                            transform: 'translateX(5px)', // Slight move to the right
                                        },
                                        '&::after': {
                                            content: '""',
                                            position: 'absolute',
                                            width: '100%',
                                            height: '2px',
                                            backgroundColor: '#f5b600',
                                            left: 0,
                                            bottom: 0,
                                            transform: menu.active == ind ? 'scaleX(1)' : 'scaleX(0)',
                                            transformOrigin: 'left',
                                            transition: 'transform 0.3s ease',
                                        },
                                        '&:hover::after': {
                                            transform: 'scaleX(1)', // Line grows from left to right
                                        },
                                    }}
                                >
                                    {page?.title}
                                </Button>
                            </Link>
                        ))}
                    </Box>

                    {/* User Avatar */}
                    <Box sx={{ flexGrow: 0 }}>
                        <Tooltip title="Wishlist">
                            <IconButton sx={{ p: 0, mr: 1 }}>
                                <CiHeart size={30} />
                            </IconButton>
                        </Tooltip>

                        {/* <Tooltip title="Open settings">
                            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                <Avatar alt="User Avatar" src="/static/images/avatar/2.jpg" />
                            </IconButton>
                        </Tooltip> */}

                        <Menu sx={{ mt: '45px' }} id="menu-appbar" anchorEl={anchorElUser} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} keepMounted transformOrigin={{ vertical: 'top', horizontal: 'right' }} open={Boolean(anchorElUser)} onClose={handleCloseUserMenu}>
                            {settings.map((setting) => (
                                <MenuItem key={setting} onClick={handleCloseUserMenu}>
                                    <Typography sx={{ textAlign: 'center' }}>{setting}</Typography>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar >
    );
}

export default Header;
